import React from 'react';
import { ArrowRight } from 'lucide-react';
interface BrutalButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline';
  children: React.ReactNode;
  className?: string;
}
export function BrutalButton({
  variant = 'primary',
  children,
  className = '',
  ...props
}: BrutalButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center px-3 sm:px-4 md:px-6 py-2 sm:py-2.5 md:py-3 font-bold text-xs sm:text-sm uppercase tracking-wider transition-transform active:translate-x-0.5 active:translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[#ccff00] focus:ring-offset-1 focus:ring-offset-black';
  const variants = {
    primary: 'bg-[#ccff00] text-black border-2 border-[#ccff00] hover:bg-white hover:border-white hover:text-black shadow-[2px_2px_0px_0px_#fafafa]',
    outline: 'bg-transparent text-[#ccff00] border-2 border-[#ccff00] hover:bg-[#ccff00] hover:text-black shadow-[2px_2px_0px_0px_#ccff00]'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-60">
      {children}
      {variant === 'primary' && <ArrowRight className="ml-1.5 h-3 w-3 sm:h-4 sm:w-4" strokeWidth={3} data-id="element-61" />}
    </button>;
}